module.exports = __webpack_public_path__ + "img/leifeng.66193895.png";